import FlagType from 'owa-service/lib/contract/FlagType';
import { action } from 'satcheljs';

/**
 * Action to propagate the flag items action to client stores
 * @param itemIds - the ids for items on which flag operation was performed
 * @param flagTypeToSet - the flag type to set on the items
 * @param parentFolderId - the parent FolderId
 */
export default action(
    'FLAG_ITEMS_STORE_UPDATE',
    (itemIds: string[], flagTypeToSet: FlagType, parentFolderId: string) => {
        return {
            itemIds,
            flagTypeToSet,
            parentFolderId,
        };
    }
);
